import { constant } from "./constant";
import { getMenu, getPageSEO, getProductList } from "../pages/api/hello";
import environment from "./environment";

export function setStorage(id: number, name: string) {
    let data = {
        id: id,
        name: name
    }
    localStorage.setItem(constant.product, JSON.stringify(data));
}

export function addKeyToImage(url: string, type: number, is630 = false, is500 = false, is350 = false, is960 = false) {
    const lastDotIndex = url.lastIndexOf(".");
    if (lastDotIndex !== -1) {
        let newUrl = url.slice(0, lastDotIndex);
        // url.slice(0, url.indexOf("."));
        let format = ".webp";
        if (is960) {
            return url;
            // return newUrl + "_960" + format;
        }
        if (is350) {
            return newUrl + "_350" + format;
        }
        if (is500) {
            return newUrl + "_530" + format;
        }
        if (is630) {
            return newUrl + "_630" + format;
        }
        
        switch (type) 
        {
            case 1: //Width > 1000
                return url;
                // return newUrl + "_530" + format;
                break;
            case 2: //Width > 768
                return newUrl + "_530" + format;
                break;
            case 3: //Width > 100
                return newUrl + "_350" + format;
                break;
            default:
                break;
        }
    }
    
    return url;
}

export function getLastUrlSegment(url:string) {
    let res = new URL(url).pathname;
    if(res.includes('/page/')){
        res = res.split('/page/')[0];
    }
    return res.split('/').filter(Boolean).pop();
}

export function setSeoSearch(keyword:string, setSeo:any) {
    setSeo({
        "id": 0,
        "keyword": [],
        "key_code": [],
        "title": keyword,
        "url": "",
        "description": null
    });
}

export function setSeoPaging(title:string, setSeo:any) {
    setSeo({
        "id": 0,
        "keyword": [],
        "key_code": [],
        "title": title,
        "url": "",
        "description": null
    });
}

export const imageLoader = ({ }) => {
    return `/asset/image/loading.svg`;
}

export const imageAlt = (alt:string, nameProduct:string) => {
    let name = nameProduct ? nameProduct : "HGS";
    return alt ? alt : name;
}

export const getMetaImg = async (url:any) => {
    try{
        const img = new Image();
        let url_temp = url;
        if(!url.includes('_350.')){
            url_temp = addKeyToImage(url, 0, false, false, true, false);
        }
        img.src = url_temp;
        await img.decode();  
        return img
    }catch(e){
        return null;
    }
    
};

export const getMetaImg_Product = async (domain:any ,url:any, innerWidth:number) => {
    let res = 500;
    try{
        
        const container = document.body;
        if(container){
            // 2. Create the wrapper div and the image element
            const wrapperDiv = document.createElement('div');
            wrapperDiv.style.width = ((innerWidth >= 700) ? "562px" : innerWidth + "px");
            wrapperDiv.style.position = "absolute";
            wrapperDiv.style.top = "-999px";
            const img = new Image();
            let url_img = domain + addKeyToImage(url, 0, (innerWidth >= 700), (innerWidth < 700), false, false);
            img.src = url_img;
            wrapperDiv.appendChild(img);
            container.appendChild(wrapperDiv);
            await img.decode(); 
            setTimeout(function(){
                wrapperDiv.remove();
            }, 1000);
            return img.height;
        }
        
        return res;
    }catch(e){
        return res;
    }
    
};
export const loadServerSideProps = async (path:any, query:any = null) => {
    
    let _fileDefault = {
        file_url: constant.url_logo,
        file_type: 'image/png',
        alt: 'Hoài Giang Shop',
        url: ""
      }
    let _return = {
            seo:{
                type: -2,
                description: constant.description_page,
                title: constant.title_page,
                file: _fileDefault
                },
            products: []
        };
    try {
        let number_paging = 1;
        if (path && path.includes("/page/")) {
            let arr_page = path.split('/page/');
            path = arr_page[0];
            number_paging = (arr_page[1] ? parseInt(arr_page[1]) : 0);
        }
        if(path && path.includes("search")){
            _return = {
                ..._return,
                seo:{
                    type: 0,
                    description: constant.description_page,
                    title: "Bạn đang tìm kiếm: ",
                    file: _fileDefault
                }
            };
        }else{
            let res = await getPageSEO(path);
            if(res){
                if(res?.file){
                    let url_min = res?.file?.file_url;
                    if(res?.file?.file_url){
                        url_min = addKeyToImage(res?.file?.file_url, 3, false, false, true, false);
                    }
                    let file_url = url_min ? environment.baseImageUrl + url_min : constant.url_logo
                    _fileDefault = {
                        ...res?.file,
                        file_url: file_url
                    }
                }
                
                res.url_root = res.url =  process.env.SITE_URL + path;
                if (res.url.endsWith('/')) {
                    res.url_root = res.url = res.url.slice(0, -1);
                }
                let temp = {
                    ...res,
                    description: res?.description ? res?.description : "",
                    title: res?.title ? res?.title + (number_paging > 1 ? " - Trang " + number_paging: "") : "",
                    // file: {..._fileDefault},
                    // url: process.env.SITE_URL + path
                }
                let linkCanonical = handleLinkCanonical(temp.url, number_paging, res.totalPages);
                
                temp = {
                    ...temp,
                    linkCanonical
                };
                if (number_paging > 1) {
                    temp.url = temp.url + "/page/" + number_paging;
                }
                if(res?.product){
                    temp.product = res?.product;
                }
                // let menus = await loadConfigSystem();
                _return = {seo: temp, products: []};
                try{
                    let hasQueryParam = (query ? 'type' in query : null);
                    if((res?.type == 0 || res?.type == 5) && !hasQueryParam){
                        let filter = {
                            "group_url": path,
                            "attributes": null,
                            "from_rental_price": 0,
                            "to_rental_price": 0,
                            "from_price_sell": 0,
                            "to_price_sell": 0,
                            "check_stock": false,
                            "branch_ids": null
                        }
                        let res_prod:any = null;
                        let arr_path = path.split('/');
                        if(res?.type == 5 && arr_path.length > 1){
                            res_prod = await getProductList(`limit=20&page=${number_paging}&from_date=&to_date=`, {
                                keyword_code: arr_path[1],
                                ...filter
                            });
                        }
                        else if(res?.type == 0){
                            res_prod = await getProductList(`limit=20&page=${number_paging}&from_date=&to_date=`, filter);
                        }
                        if(res_prod){
                            _return = {
                                ..._return,
                                products: res_prod
                            } 
                        }
                        
                    }
                }catch(ex){

                }
            }
        }
      } catch (error) {
        console.log("error", error);
      }
      
      return _return;
};

async function loadConfigSystem(){
    let res:any = [];
    try{
        res = await getMenu();
        if (!res) {
            res = [];
        }
        
    }catch(ex){
        console.log("ex: ", ex);
    }
    return res;
    
    // let arr_menu:any = await loadMenu();
   
    // let arr_setting:any = await loadSystemSetting();
    
    // let arr_branch:any = await loadBranchs();
    // let workingTime:any = await loadWorkingTime();
    // console.log("arr_menu: ",arr_menu);
}

async function setLocalStorage(key_name:string, res:any){
    try{
        await localStorage.removeItem(key_name);
        var object = {value: res, timestamp: new Date().getTime()};
        await localStorage.setItem(key_name, JSON.stringify(object));
    }
    catch(e:any){

    }
}

export const chkUrl = (url:any) => {
    try{
        if(url){
            let result = url;
            if(!url.includes("https://") && !url.includes("http://")){
                let firstChar = url[0];
                if(firstChar !== "/"){
                    result = "/" + url;
                }
            }
            return result;
        }else{
            return "#";
        }
        
    }catch(ex){
        return "#";
    }
}

export const handleLinkCanonical = (url_root:string, paging?:number, totalPages?:number) => {
    let result = {
        url_next: "",
        url_prev: ""
    }
    let number_paging = (paging && paging > 0 ? paging : 1);
    if(number_paging >= 1 && totalPages && number_paging < totalPages){
        result.url_next = url_root + "/page/" + (number_paging + 1);
    }
    if (number_paging > 1) {
        if(number_paging > 1 && totalPages && number_paging <= totalPages){
            let total = (number_paging > totalPages ? totalPages : number_paging);
            result.url_prev = url_root + ((number_paging - 1) > 1 ? "/page/" + (total - 1) : "");
        }
    }
    return result;
}